<template>
  <div>
    <rc-radio :value="value" :label="radioLabel(row)" />
  </div>
</template>

<script>
import RcRadio from "@/components/RcBase/RcRadio";
import { indexOf } from "@/utils";

export default {
  name: "RcRadioType",
  components: {
    RcRadio
  },
  props: {
    column: Object,
    row: Object,
    value: [Number, String, Boolean]
  },
  data() {
    return {
      radio: ""
      // value: ''
    };
  },
  computed: {
    columnsType() {
      // const types = filterColumns({ data: this.columns, type: 'type', isFilter: true });
      const types = [];
      const typesVal = types.map(item => item.type);
      const isRadio = this.filterType(typesVal, "radio");
      const isSelection = this.filterType(typesVal, "selection");
      return {
        types,
        typesVal,
        isRadio,
        isSelection
      };
    },
    typeRadio() {
      return this.columnsType.isRadio;
    },
    typeSelection() {
      return this.columnsType.isSelection;
    }
  },
  methods: {
    radioLabel(row) {
      return row && `____radio${row.id}`;
    },
    setSelection(row) {
      this.setSelectionRow(row);
    },
    setSelectionRow(row) {
      if (row) {
        const current = row && row[this.$attrs.rowKey];
        const { index, arr } = indexOf({ key: current });
        this.selection = arr;
        this.setRowSelection(index === -1 ? row : "");
      }
    },
    setRowSelection(row) {
      this.table.toggleRowSelection(row);
    },
    showRadio({ type }, col) {
      return this.isRadio(type) && this.isRadio(col);
    },
    currentChange(row, oldRow) {
      this.typeRadio && this.setRow(row, "radio");
    },
    rowClick(row, column, event) {
      this.typeSelection && this.setRow(row, "selection");
    },
    setRow(row, type) {
      if (this.needClick) {
        this.table.setCurrentRow(row);
        // this.typeRadio && this.table.clearSelection();
        // this.highlightCurrentRowState(Boolean(this.typeRadio));
        // this.radio = this.radioLabel(row);
        // this.setSelection(row);
      }
    },
    goRoute(row, column) {
      const { name, rowKey, key } = column;
      this.$router.push({ name, query: { [key || "id"]: row[rowKey || this.rowKey] }});
    },
    setRadio(val) {
      this.currentChange(val);
    },
    clearRadio() {
      this.setRadio(null);
    }
  }
};
</script>

<style>

</style>
